export default "__VITE_ASSET__BJ71XNsf__"